import React, { useEffect } from "react";
import { connect } from "react-redux";
import { HOST_URL } from "../../utils/misc";

const CardIntroAbout = (props) => {
  return (
    <>
      <div className="container" style={{ marginTop:50 }}>
          <div className="row">
            <div className="col-md-4 col-xs-12" id="contentAboutUs">
                <div className="p-4" style={{ background:`linear-gradient(${props.templates.templates.templateProperties.background_card_intro_about_first}, ${props.templates.templates.templateProperties.background_card_intro_about_second})`,
                  color: `${props.templates.templates.templateProperties.text_color_card_intro_about}`
                }}>
                    <h4 style={{ fontSize:20 }}>{props.templates.templates.templateProperties.title_card_intro_about}</h4>
                    <h6 style={{ fontSize:25 }}>{props.templates.templates.templateProperties.store_name}</h6>
                    <hr style={{ backgroundColor: `${props.templates.templates.templateProperties.text_color_card_intro_about}` }} />
                    <p style={{ fontWeight: 380, textAlign: "justify" }}>{props.templates.templates.templateProperties.content_card_intro_about}</p>
                </div>
            </div>
            <div className="col-md-8 col-xs-12 imageIntroAbout">
                <img src={HOST_URL + props.templates.templates.templateProperties.image_card_intro_about} style={{ width:"100%" }} />
            </div>
          </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
      templates: state.templates,
  };
};

export default connect(mapStateToProps)(CardIntroAbout);
